import styled from 'styled-components'
import { bp } from 'lib/core/resources/helpers/styled'
import { containerCss } from 'app/sofia/components/Structure/Container'
import TopBorder from 'resources/svg/brands-topborder.svg'
import { BP } from 'resources/constants'
import CaretSvg from 'resources/svg/icons/caret-right.svg'
import { buttonSizeLg, buttonPrimary } from 'app/sofia/resources/theme/css'

export const Wrapper = styled.div``

export const Container = styled.div`
  background: ${props => props.theme.palette.general.light};
  position: relative;
  padding: 30px 0 20px;
  margin: 30px 0 0;
  z-index: 1;
  overflow: hidden;

  svg.pattern {
    position: absolute;
    left: -167px;
    width: 349px;

    @media (max-width: ${BP.sm.min}) {
      display: none;
    }

    * {
      stroke: #a1d7e5;
    }

    &-right {
      left: unset;
      right: -195px;
      transform: rotate(210deg);
      bottom: 0;
    }
  }

  @media (min-width: ${BP.sm.min}) {
    margin: 30px 0 0;
  }

  @media (min-width: ${BP.md.min}) {
    padding: 20px 0 50px;
    margin: 50px 0 0;
  }

  &::before {
    content: '';
    display: block;
    background: url(${TopBorder}) center bottom no-repeat;
    background-size: 100vw;
    position: absolute;
    top: -90px;
    width: 100%;
    height: 100px;
    z-index: -1;
  }

  > div {
    ${containerCss};
    text-align: center;
  }

  h2 {
    ${props => props.theme.css.heading2};
    line-height: 1.2;
  }

  p,
  h2 {
    text-align: center;
  }

  a {
    ${props => props.theme.css.link};
    font-size: 20px;
  }
`

export const ProductsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  grid-gap: 40px 5vw;
  max-width: 80vw;
  margin: 40px auto 50px;
  ${bp('sm')`
    max-width: 56vw;
  `}
`

export const ItemWrapper = styled.div`
  min-width: 150px;
  max-width: 290px;

  .product {
    &-attribute {
      li {
        display: flex;
        justify-content: center;
        align-items: center;

        svg {
          width: 45px;
          height: 45px;
          ${bp('sm')`
            width: 30px;
            height: 30px;
          `}
        }

        span {
          margin-left: 20px;
          font-size: 18px;
          color: ${props => props.theme.palette.general.strong};
          width: 125px;
          text-align: left;
        }
      }
    }

    &-info {
      text-align: center;

      img {
        max-width: 100%;
      }

      a {
        ${buttonPrimary};
        margin-top: 20px;

        @media (min-width: ${BP.md.min}) {
          ${buttonSizeLg}
        }

        &::after {
          content: '';
          margin-left: 12px;
          width: 11px;
          height: 16px;
          background: url(${CaretSvg}) no-repeat center;
          background-size: 8px;
          filter: invert(100%) sepia(1%) saturate(7494%) hue-rotate(273deg) brightness(103%) contrast(97%);
          display: inline-block;
        }
      }
    }

    &-image {
      width: 100%;
      padding-bottom: 75%;
      background-size: 100%;
      background-repeat: no-repeat;
      background-position: center;
      margin: 10px 0;
      ${bp('sm')`
        max-width: 190px;
        margin: 10px auto;
      `}
    }
  }
`
